export default __webpack_public_path__ + "static/media/bannervideo2.7656d47e.mp4";